/** @jsx jsx */
import { Box, Grid, Heading, jsx, Text } from 'theme-ui'
import ListingCardImage from '~/components/Listing/Card/Image'
import ProductLink from '~/components/Product/Link'
import LinkedReviewStars from '~/components/Reviews/LinkedStars'

const ListingCardEmbed = ({
  addToCart,
  callout,
  hoverImage,
  mainImage,
  name,
  reviewlessCallout,
  reviewsSlug,
  shortDescription,
  slug,
  slugUrl,
  subtitle,
  tag,
}) => {
  return (
    <Grid
      columns={[1, null, 2]}
      sx={{
        alignItems: 'center',
        bg: 'white',
        columnGap: [0, null, 3],
        margin: '0 auto',
        maxWidth: ['400px', null, 'none'],
        rowGap: 0,
      }}
    >
      <Box>
        <ListingCardImage
          callout={callout}
          hoverImage={hoverImage}
          mainImage={mainImage}
          name={name}
          slug={slug}
          slugUrl={slugUrl}
          tag={tag}
        />
      </Box>
      <Box p={3} pl={[null, null, 0]}>
        <Heading as="h2" variant="title5" mb="4px">
          <ProductLink
            slug={slug}
            slugUrl={slugUrl}
            sx={{
              color: 'black',
              display: 'block',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            {name}
          </ProductLink>
        </Heading>
        {subtitle && (
          <Text
            as="h3"
            variant="body3"
            mb={1}
            mr={-1}
            sx={{
              color: 'greyDark',
              fontWeight: 'normal',
            }}
          >
            {subtitle}
          </Text>
        )}
        {reviewlessCallout && (
          <Text as="p" mb="2px" variant="callout3" color="brandTertiary">
            {reviewlessCallout}
          </Text>
        )}
        {!reviewlessCallout && (
          <LinkedReviewStars
            id={reviewsSlug || slug}
            mb="4px"
            mt="4px"
            to={`/products/${slugUrl || slug}/`}
          />
        )}
        <Text as="p" variant="body3" mt={1}>
          {shortDescription}
        </Text>
        <Box mt={2}>{addToCart}</Box>
      </Box>
    </Grid>
  )
}

export default ListingCardEmbed
